import { useEffect, useRef, useCallback, useMemo } from 'react';
import { useBoolean, useArray, useNumber, useStateful } from 'react-hanger';

/**
 * 不建议使用，移步 /README.md  ##页面全屏背景色
 * @param className
 */
const usePageClass = (className) => {
  useEffect(() => {
    if (className) {
      if (typeof document !== 'undefined') {
        document.querySelector('html').classList.add(className);
      }

      return () => {
        if (typeof document !== 'undefined') {
          document.querySelector('html').classList.remove(className);
        }
      };
    }
  }, [className]);
};

export default usePageClass;
